// extracted by mini-css-extract-plugin
export var hideEditor = "_kp-2";
export var infoIcon = "_kp-3";
export var label = "_kp-1";
export var labelContainer = "_kp-0";
export var readonlyText = "_kp-4";